(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.BiscuitEditorialHeader');

    if (!header || header.dataset.condenseInitialized === 'true') {
      return;
    }

    header.dataset.condenseInitialized = 'true';

    let ticking = false;

    const updateHeader = () => {
      const collapseThreshold = header.classList.contains('is-condensed') ? 2 : 12;
      header.classList.toggle('is-condensed', window.scrollY > collapseThreshold);
      ticking = false;
    };

    const requestHeaderUpdate = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(updateHeader);
    };

    const syncHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };

    window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
    window.addEventListener('resize', requestHeaderUpdate);
    new ResizeObserver(syncHeaderHeight).observe(header);

    updateHeader();
    syncHeaderHeight();
  })();

  } catch(e) { console.error(e); }
})();
})();
